module.exports = window.wp.undoManager;